<script setup lang="ts">
import {
  AccordionTrigger,
  AccordionTriggerProps,
  useForwardProps,
} from 'radix-vue'

import Icon from '../Icon/Icon.vue'

const props = defineProps<AccordionTriggerProps>()
const forwarded = useForwardProps(props)
</script>

<template>
  <AccordionTrigger
    v-bind="forwarded"
    class="bg-neutral-light-3 group flex h-8 w-full flex-1 cursor-pointer items-center justify-between gap-2 p-2 text-sm font-bold transition-all"
    data-size="large"
  >
    <slot></slot>
    <Icon
      class="transition-transform duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-data-[state=open]:rotate-180"
      icon="chevron-down"
      aria-label="Expand/Collapse"
    />
  </AccordionTrigger>
</template>
